/**
 * Kept out of main.tsx: the crash fallback above createRoot there must use
 * literal colours only (tests/test_theme_contrast.py), and this one reads the
 * theme's variables, which is right for a working app.
 */
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from '@/stores/authStore';
import { useTechLocked } from '@/components/Tech/lockState';

/**
 * The app's one Toaster. While the technician's PIN lock is up its toasts go
 * UNDER the lock (z 70 < the lock's 80), so nothing is readable over it
 * (FM Technician review R2-2; the queue's own toasts wait for the unlock).
 */
export default function AppToaster() {
  const uid = useAuthStore((st) => st.user?.id ?? null);
  const locked = useTechLocked(uid);
  return (
          <Toaster
            position="top-right"
            containerClassName={locked ? '!z-[70]' : undefined}
            // Below a live emergency banner, never over it: EmergencyBanner
            // publishes its height in this variable (0px when none is live,
            // which leaves the default 16px inset exactly as it was).
            containerStyle={{ top: 'calc(var(--emergency-banner-h, 0px) + 16px)' }}
            toastOptions={{
              duration: 4000,
              style: {
                background: 'rgb(var(--color-surface-inverse))',
                color: 'rgb(var(--color-surface-subtle))',
                fontSize: '0.875rem',
                borderRadius: '0.75rem',
                padding: '0.75rem 1rem',
              },
              success: {
                iconTheme: { primary: 'rgb(var(--color-success-surface-500))', secondary: 'rgb(var(--color-surface-subtle))' },
              },
              error: {
                iconTheme: { primary: 'rgb(var(--color-danger-surface-500))', secondary: 'rgb(var(--color-surface-subtle))' },
              },
            }}
          />
  );
}
